import "@/helpers/turbo"

import { setupSearchBar } from "@/components/search_bar"

setupSearchBar()
